<template>
  <div class="code-editor">
    <h3 class="code-editor__header">{{ title }}</h3>
    <div class="code-editor__body">
      <pre
        v-if="code"
      ><code ref="code" :class="[codeType]" v-html="code"></code></pre>
      <div v-else class="code-editor__empty">{{ defaultEmptyText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeEditor",

  props: {
    title: {
      type: String
    },

    code: {
      type: String
    },

    codeType: {
      type: String,
      default: "java"
    },

    defaultEmptyText: {
      default: "暂无数据"
    }
  },

  watch: {
    code() {
      this.$nextTick(() => {
        this.toHljs(this.$refs.code);
      });
    }
  },

  mounted() {
    this.toHljs();
  },

  methods: {
    toHljs(dom) {
      // hljs 由cdn引入
      // eslint-disable-next-line
      dom && this.code && hljs.highlightBlock(dom);
    }
  }
};
</script>

<style lang="less">
.code-editor {
  margin-top: 16px;
  max-width: 900px;
  overflow: hidden;
  border: 1px solid #e8eaec;

  // reset
  .hljs {
    padding: 10px 18px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #282c34;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #555;
    }
  }

  &__header {
    background: #f8f8f9;
    line-height: 40px;
    border-bottom: 1px solid #e8eaec;
    color: @color-font-primary;
    font-size: 14px;
    font-weight: 500;
    padding: 0px 18px;
  }

  &__body {
    border-top: none;
    border-bottom: none;
    word-break: break-all;
    position: relative;
    max-height: 500px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #282c34;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #555;
    }
  }

  &__empty {
    display: block;
    height: 48px;
    line-height: 48px;
    text-align: center;
  }
}
</style>
